import { ChangeDetectionStrategy, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectUrl } from '../../../../router.selectors';
import { combineLatest, filter, map } from 'rxjs';
import { MenuBarService } from '../menu-bar.service';

@Component({
  selector: 'osn-cxb-settings-menu',
  templateUrl: './settings-menu.component.html',
  styleUrls: ['./settings-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsMenuComponent implements OnInit {
  public settingsMenuItems$ = this.menuBarService.settingsMenuItems$;
  public isSettingsPageActive$ = combineLatest([this.menuBarService.settingsMenuItems$, this.store.select(selectUrl)]).pipe(
    filter(([menuItems, currentUrl]) => !!menuItems?.length && !!currentUrl),
    map(([menuItems, currentUrl]) => {
      return !!menuItems.some((item: { url: string; title: string }) => currentUrl.includes(item.url));
    })
  );

  public menuVisible = false;

  constructor(private readonly menuBarService: MenuBarService, private readonly eRef: ElementRef, private readonly store: Store) {}

  public ngOnInit(): void {}

  @HostListener('document:mousedown', ['$event'])
  public outsideClick(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.menuVisible = false;
    }
  }

  public onSettingsMenuClick() {
    this.menuVisible = true;
  }

  public onSettingsMenuOptionClick() {
    this.menuVisible = false;
  }
}
